export default {"src":"/_next/static/media/recurringDepositBlue.2007dd68.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};